import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { compose } from 'recompose';
import { withTrack } from '@dpdgroupuk/react-event-tracker';

import TrackAnotherParcelButton from '../../../components/TrackAnotherParcelButton';
import { NOT_PAID_MESSAGE } from '../../../../../constants/message';
import {
  DTY_CANCELLATION_COMPLETE,
  trackable,
} from '../../../../../constants/analytics';

const useStyles = makeStyles(({ typography, breakpoints }) => ({
  text: {
    fontSize: typography.pxToRem(20),
    maxWidth: '68%',
    marginBottom: typography.pxToRem(35),
    [breakpoints.down('xs')]: {
      fontSize: typography.pxToRem(15),
      marginBottom: typography.pxToRem(15),
    },
  },
}));

const CancelledConfirmation = () => {
  const styles = useStyles();

  return (
    <>
      <Typography className={styles.text}>{NOT_PAID_MESSAGE}</Typography>
    </>
  );
};

export default compose(withTrack(trackable(DTY_CANCELLATION_COMPLETE)))(
  CancelledConfirmation
);
